import { render, staticRenderFns } from "./AdAccountIcon.vue?vue&type=template&id=5e315b57&scoped=true"
import script from "./AdAccountIcon.vue?vue&type=script&lang=js"
export * from "./AdAccountIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e315b57",
  null
  
)

export default component.exports